import { combineReducers } from "redux";
import sidebarToggle from "./slices/sidebarToggle";
import auth from "./slices/authSlice";
import citySlice from "./slices/citySlice";
import patientSlice from "./slices/patientSlice";
import clinicSlice from "./slices/clinicSlice";
import userTypeSlice from "./slices/userTypeSlice";
import countrySlice from "./slices/countrySlice";
import stateSlice from "./slices/state";
import physicianSlice from "./slices/physicianSlice";
import specializations from "./slices/specializationSlice";
import serviceSlice from "./slices/serviceSlice";
import clinicTestMaster from "./slices/clinicTestMaster";
import clinicLabProfile from "./slices/clinicLabProfile";
import category from "./slices/categorySlice";
import appointmentSlice from "./slices/appointmentSlice";
import invoice from "./slices/invoiceSlice";
import languageSlice from "./slices/languageSlice";
import educationSlice from "./slices/educationSlice";
import users from "./slices/userSlice";
import clinicHairServiceMaster from "./slices/clinicHairServiceMaster";
import clinicDentalServiceMaster from "./slices/clinicDentalServiceMaster";
import clinicSkinServiceMaster from "./slices/clinicSkinServiceMaster";
import clinicGeneralServiceMaster from "./slices/clinicGeneralServiceMaster";
import treatment from "./slices/treatmentSlice";
import labReport from "./slices/labReportSlice";
import liscode from "./slices/liscodeSlice";
import branches from "./slices/branchSlice";
import clinicRadiologyService from "./slices/clinicRadiologyService";
import clinicRadiologyServiceDetails from "./slices/clinicRadiologyServiceDetails";
import radiologyReport from "./slices/radiologyReport";
import referalAmount from './slices/referrerList';
import accountType from "./slices/accountType";
import bank from "./slices/bankSlice";
import clinicUser from "./slices/clinicUserSlice";
import role from "./slices/roleSlice";
import packageMaster from "./slices/packageMaster.slice";
import healthScreening from "./slices/healthScreening.slice";
import unRegisteredClinic from "./slices/unRegisteredClinic";
import clientType from "./slices/clientTypeSlice";
import Camp from "./slices/campSlice";
import client from "./slices/client.slice";
import membership from "./slices/membershipSlice";
import sales from "./slices/sales";
import physiotherapyService from "./slices/physioserviceSlice";
import referrerList from './slices/referrerList';
import medicalCertificate from './slices/medicalCertificate.slice';
import referralCommission from './slices/referralCommission.slice';
import application from "./slices/application";
import tableStatusChange from "./slices/tableStatusChange";
import paymentHistory from "./slices/physicianPaymentSlice";
import supplier from "./slices/supplierSlice";
import gstinType from "./slices/gstinTypeSlice";
import tablePaidStatus from "./slices/tablePaidStatus"; 
import tax from "./slices/taxSlice"; 
import purchase from "./slices/purchaseSlice";
import medicineType from "./slices/medicineTypeSlice"; 
import clientPrice from "./slices/clientPriceSlice";
import medicineMaster from "./slices/medicineMasterSlice";
import stockInventory from "./slices/stockInventorySlice";
import district from './slices/districtSlice'
import abhaRegistration from "./slices/abhaRegistrationSlice"
import pharmaSales from "./slices/pharmaSalesSlice";
import clientBill from "./slices/clientBillSlice";
import pharmaSalesRetailer from "./slices/pharmaSalesRetailerSlice";
import retailer from "./slices/retailerSlice";
import contactSlice from "./slices/contactSlice";
import PharmaSettlement from "./slices/pharmaSettlementSlice";
import BiopsyTracking from "./slices/biopsy";
import misReport from "./slices/misReportSlice";
import sampleCollection from "./slices/sampleCollectionSlice";
import shareAbhaDataM3 from "./slices/shareAbhaDataM3Slice";
import testSampleType from "./slices/testSampleTypeSlice";
import testMethod from "./slices/testMethodSlice";

const rootReducer = combineReducers({
  sidebarMenu: sidebarToggle,
  auth,
  city: citySlice,
  country: countrySlice,
  patient: patientSlice,
  clinic: clinicSlice,
  state: stateSlice,
  userType: userTypeSlice,
  physician: physicianSlice,
  specializations: specializations,
  service: serviceSlice,
  clinicTestMaster,
  clinicLabProfile,
  category,
  appointmentSlice,
  invoice,
  languages: languageSlice,
  educations: educationSlice,
  users,
  clinicGeneralServiceMaster,
  clinicHairServiceMaster,
  clinicDentalServiceMaster,
  clinicSkinServiceMaster,
  treatment,
  labReport,
  liscode,
  branches,
  clinicRadiologyService,
  clinicRadiologyServiceDetails,
  radiologyReport,
  referalAmount,
  accountType,
  bank,
  clinicUser,
  role,
  packageMaster,
  healthScreening,
  unRegisteredClinic,
  clientType,
  Camp,
  client,
  membership,
  sales,
  physiotherapyService,
  referrerList,
  medicalCertificate,
  referralCommission,
  application,
  tableStatusChange,
  paymentHistory,
  supplier,
  gstinType,
  tablePaidStatus,
  tax,
  purchase,
  medicineType,
  clientPrice,
  medicineMaster,
  stockInventory,
  district,
  abhaRegistration,
  pharmaSales,
  clientBill,
  pharmaSalesRetailer,
  retailer,
  contact: contactSlice,
  PharmaSettlement,
  BiopsyTracking,
  misReport,
  sampleCollection,
  shareAbhaDataM3,
  testSampleType,
  testMethod,
});

export default rootReducer;